<template>
  <div class="page-content">
    <el-form
      ref="form"
      :model="formdata"
      :rules="rules"
      style="width:500px;"
    >
     <!--  <el-form-item
        label="用户名"
        prop="userName"
      >
        <el-input v-model="formdata.userName"
       />
      </el-form-item> -->

      <el-form-item
        label="旧密码"
        prop="old_password"
      >
      <!-- <el-input type="password" style="position:fixed;bottom:-9999px"
       /> -->
        <el-input
          v-model="formdata.old_password"
          type="password"
        />
      </el-form-item>

      <el-form-item
        label="新密码"
        prop="password"
      >
        <el-input
          v-model="formdata.password"
          type="password"
        />
      </el-form-item>

      <el-form-item
        label="确认密码"
        prop="password2"
      >
        <el-input
          v-model="formdata.password2"
          type="password"
        />
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
        >
          修改密码
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { loginVt } from '@/api/login'
import { updatePwd } from '@/api/user'
import { jsEncrypt } from '@/utils'
export default {
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formdata.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      oldPasswordRsa: '',
      newPasswordRsa: '',
      formdata: {
        // userName: '',
        password: '',
        old_password: '',
        password2: ''
      },
      rules: {
        // userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        old_password: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        password2: [{ required: true, validator: validatePass2, trigger: 'blur' }]
      }
    }
  },
  methods: {
    onSubmit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            regName: localStorage.getItem('userName')
          }
          loginVt(params).then(res => {
            this.key = res.data.data
            this.oldPasswordRsa = jsEncrypt.encryptPublic(this.formdata.old_password, this.key) // rsa根据公钥加密旧密码
            this.newPasswordRsa = jsEncrypt.encryptPublic(this.formdata.password, this.key) // rsa根据公钥加密新密码
          }).then(() => {
            const aparams = {
              oldPassword: this.oldPasswordRsa,
              newPassword: this.newPasswordRsa
            }
            updatePwd(aparams).then(res => {
              if (res.data.code === 0 || res.data.code === 200) {
                this.$message({
                  message: '密码修改成功',
                  type: 'success'
                })
                this.$router.push('/login')
              }
            })
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
